import React from "react";
import { Card, Button } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import PageTitle from "../layouts/PageTitle";

const Co_host_Detail = () => {
  const navigate = useNavigate();
  const events = [
    {
      id: 1,
      name: "Sangeet Night",
      date: "12 Dec 2025",
      startTime: "7:00 PM",
      venue: "Grand Palace, Lucknow",
      theme: "Bollywood Night",
      dressCode: "Traditional",
      dressColor: "Golden & Red",
    },
    {
      id: 2,
      name: "Wedding Ceremony",
      date: "15 Dec 2025",
      startTime: "11:00 AM",
      venue: "Royal Heritage Resort",
      theme: "Classic Indian",
      dressCode: "Sherwani / Lehenga",
      dressColor: "Maroon & Cream",
    },
  ];

  const location = useLocation();
  const historyData = location.state?.history;
  const hostName = historyData?.user?.hostName || "Co-Host";

  return (
    <div className="qx-page">
      <PageTitle
        pageTitle={`${hostName} — Co-Host Events`}
        subtitle="View events assigned to this co-host"
        actions={
          <Button variant="outline-secondary" onClick={() => navigate(-1)}>
            Back
          </Button>
        }
      />

      <Card className="qx-section-card mb-4">
        <Card.Body className="p-0">
          {events.map((event) => (
            <div key={event.id} className="qx-event-item">
              <div className="d-flex flex-column flex-md-row justify-content-between align-items-start gap-3">
                <div className="flex-grow-1">
                  <h5 className="fw-semibold mb-3">{event.name}</h5>
                  <div className="row g-2">
                    {[
                      ["Date", event.date],
                      ["Start Time", event.startTime],
                      ["Venue", event.venue],
                      ["Theme", event.theme],
                      ["Dress Code", event.dressCode],
                      ["Dress Color", event.dressColor],
                    ].map(([label, value]) => (
                      <div key={label} className="col-sm-6">
                        <div className="qx-detail-field">
                          <span className="qx-detail-field__label">{label}</span>
                          <span className="qx-detail-field__value">{value}</span>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
                <Button className="btn-primary qx-btn-brand flex-shrink-0" onClick={() => navigate(-1)}>
                  View Details
                </Button>
              </div>
            </div>
          ))}
        </Card.Body>
      </Card>
    </div>
  );
};

export default Co_host_Detail;
